import React from 'react';

const Clientes = () => {
  // Array con los logos de los clientes
  const logos = [
    '/logos-clientes/1.png',
    '/logos-clientes/2.png',
    '/logos-clientes/3.png',
    '/logos-clientes/4.png',
    '/logos-clientes/5.png',
    '/logos-clientes/6.png',
    '/logos-clientes/7.png',
    '/logos-clientes/8.png',
    '/logos-clientes/9.png',
    '/logos-clientes/10.png',
    '/logos-clientes/11.png',
    '/logos-clientes/12.png',
  ];

  return (
    <section className="py-16 bg-gray-50 overflow-hidden">
      <div className="container-custom">
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="inline-flex items-center px-4 py-2 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-6">
            Nuestros Clientes
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Empresas que Confían en
            <span className="text-gradient"> Nosotros</span>
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Colaboramos con las principales empresas del sector industrial,
            brindando soluciones confiables y de alta calidad.
          </p>
        </div>

        {/* Carrusel de Logos */}
        <div className="relative">
          <div className="flex items-center">
            {/* Contenedor del carrusel con animación y efecto brush */}
            <div className="carrusel-container">
              <div className="flex animate-scroll">
                {/* Primera tanda de logos */}
                {logos.map((logo, index) => (
                  <div
                    key={`logo-1-${index}`}
                    className="cliente-logo"
                  >
                    <img
                      src={logo}
                      alt={`Cliente ${index + 1}`}
                    />
                  </div>
                ))}
                {/* Segunda tanda de logos para crear el efecto infinito */}
                {logos.map((logo, index) => (
                  <div
                    key={`logo-2-${index}`}
                    className="cliente-logo"
                  >
                    <img
                      src={logo}
                      alt={`Cliente ${index + 1}`}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Mensaje adicional */}
        <div className="text-center mt-12">
          <p className="text-gray-600 mb-4">
            ¿Listo para unirte a nuestras empresas clientes satisfechas?
          </p>
          <button
            onClick={() => window.location.href = '/contact'}
            className="btn-primary px-8 py-3"
          >
            Contáctanos Hoy
          </button>
        </div>
      </div>
    </section>
  );
};

export default Clientes;